import { useLingui } from "@lingui/react";
import { formatNumber } from "@mobility-item-page/utilities";
import { useAppConfig } from "src/context/AppConfigProviderContext.tsx";
import FieldValuePair from "../../FieldValuePair.tsx";
import type { SpecProps } from "../types.ts";

export const LiftCapacity = ({ liftCapacity }: SpecProps<"lift_capacity">) => {
  const { i18n } = useLingui();
  const { locale } = useAppConfig();

  if (!liftCapacity) {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.liftCapacity",
    message: "Lift capacity",
    comment: "Label for 'Lift capacity'",
  });

  const liftCapacityValue = i18n.t({
    id: "itemPageLayout.common.weight.postfix",
    message: "{weight} kg",
    comment: "Weight incl. postfix",
    values: {
      weight: formatNumber(liftCapacity, locale),
    },
  });
  return <FieldValuePair field={field} value={liftCapacityValue} />;
};
